import "../../../../App.css"
import { useEffect, useState } from 'react';
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, DropdownButton, Table } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CreateCategoryType, getAllCategoryType, UpdateCategoryType } from "../../../api/categorytype"
function CategoryType() {

    const [srno, setSrno] = useState("");
    const [category, setCategory] = useState("");
    const [active, setActive] = useState(true);
    const [categoryType, setCategoryType] = useState([]);
    const [error, setError] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [errors, setErrors] = useState({});
    const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [categoryResponse] = await Promise.all([
                    getAllCategoryType(token),
                ]);
                setCategoryType(categoryResponse.data);
                console.log("All category type :", categoryResponse.data)
            } catch (error) {
                setError("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, [token]);


    const handleSubmit = async () => {
        const newErrors = {};
        if (!category.trim()) {
            newErrors.category = "Category Type is Required";
        } else if (!/^[A-Za-z\s]+$/.test(category)) {
            newErrors.category = "Only letters and spaces are allowed";
        }
        if (!active) {
            newErrors.active = "Active field is required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        const categoryTypeData = {
            description: category,
            active: active
        };

        try {
            if (isEditing) {
                // Update existing record
                await UpdateCategoryType(editingId, token, categoryTypeData);
                toast.success("Category Type updated successfully!");
            } else {
                // Create new record
                await CreateCategoryType(categoryTypeData, token);
                toast.success("Category Type created successfully!");
            }

            const updatedCategoryResponse = await getAllCategoryType(token);
            setCategoryType(updatedCategoryResponse.data);
            setCategory("");
            setActive(true);
            setIsEditing(false);
            setEditingId(null);
        } catch (err) {
            console.error(err);
            toast.error("Failed to save Category Type. Please try again.");
        }
    };

    const handleEdit = (item) => {
        setIsEditing(true);
        setEditingId(item.id);
        setSrno(item.id || "");
        setCategory(item.description || "");
    };
    const handleCancel = () => {
        setCategory("");
        setActive(true);
        setError({});
        setIsEditing(false);
    }

    return (
        <>
            <NavbarVerical />
            <div className="content-area">
                <Card>
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Category Type</p>
                        <Form>
                            <Row className='mt-4'>
                                <Col>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-3 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Category Type<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={7} className="mb-3 mb-lg-0">
                                            <Form.Control type="text" placeholder="Enter Category Type"
                                                id="category" required
                                                name='category'
                                                value={category}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setCategory(value);
                                                    if (!/^[A-Za-z\s]*$/.test(value)) {
                                                        setErrors(prev => ({ ...prev, category: "Only letters and spaces are allowed" }));
                                                    } else if (value.trim() === "") {
                                                        setErrors(prev => ({ ...prev, category: "Category Type is Required" }));
                                                    } else {
                                                        setErrors(prev => ({ ...prev, category: "" }));
                                                    }
                                                }}

                                            />
                                            {errors.category && (
                                                <div
                                                    style={{
                                                        color: "red",
                                                        fontSize: "13px",
                                                        marginTop: "3px",
                                                    }}
                                                >
                                                    {errors.category}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Form.Label className="col-sm-3 col-form-label form-label">
                                            Active<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col className="mt-2">
                                            <Form.Check
                                                type="switch"
                                                id="active"
                                                label="Check If Active"
                                                checked={active}
                                                onChange={(e) => {
                                                    setActive(e.target.checked);
                                                    if (!e.target.checked) {
                                                        setErrors(prev => ({ ...prev, active: "Active field is required" }));
                                                    } else {
                                                        setErrors(prev => ({ ...prev, active: "" }));
                                                    }
                                                }}
                                            />
                                            {errors.active && (
                                                <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                                    {errors.active}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>

                                </Col>
                                <Col>
                                    <div style={{ maxHeight: '300px', overflowY: 'auto', scrollbarWidth: 'thin' }} className="custom-scrollbar mt-2">
                                        <Table striped bordered hover style={{ tableLayout: 'fixed', width: '100%' }}>
                                            <thead style={{
                                                position: 'sticky',
                                                top: '0',
                                                backgroundColor: 'white',
                                                zIndex: 1, // Ensure it's above the scroll content
                                                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)', // Add a light shadow effect to the header
                                            }}>
                                                <tr>
                                                    <th style={{ width: "150px" }}>Action</th>

                                                    <th>Category Type</th>
                                                    <th>Is Active</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {categoryType.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td style={{ textAlign: "center" }}>
                                                            <Button variant="secondary" type="button" size="sm"
                                                                onClick={() => handleEdit(item)}>
                                                                <i className="bi bi-pencil-fill me-2" />Edit
                                                            </Button>
                                                        </td>

                                                        <td>{item.description}</td>
                                                        <td>{item.active ? "Yes" : "No"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col className="d-flex align-items-center justify-content-center mb-3 mt-4">
                                    <Button variant="primary" type="button"
                                        onClick={handleSubmit}
                                    >
                                        {isEditing ? "Update" : "Submit"}
                                    </Button>
                                    <ToastContainer />
                                    <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>


                        </Form>
                    </Card.Body>
                </Card>
            </div>


        </>
    );
}

export default CategoryType;